// extracted by mini-css-extract-plugin
module.exports = {"buy":"styles_buy__1go7d","dropsTitle":"styles_dropsTitle__30PBT","dropsDate":"styles_dropsDate__qV2Vx"};